<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<app-part-number-changes-additional-input
        (deleteClick)="delete()"
        [additionalIndex]="additionalIndex"
        [additionalTypeCypressTag]="fullLotNumberCypressTag"
        [baseClass]="STYLE_TAG"
        [isDetailMode]="isDetailMode"
        [isInViewMode]="isInViewMode"
        [isSolvedStatus]="isSolvedStatus"
        [isDetailSolvedTrial]="isDetailSolvedTrial"
        [labelAdditional]="LABEL_ADDITIONAL"
        [isSolutionAccepted]="isSolutionAccepted"
        [labelNew]="LABEL_NEW">
    <app-input-text #fullLotNumberInput
                    (inputStateChange)="manageLotNumberMessages($event)"
                    (inputValueChange)="lotNumberChange($event)"
                    [baseCypressTag]="fullLotNumberBaseCypressTag"
                    [isToUpperCaseInputTextValue]="true"
                    [initialValue]="fullLotNumber"
                    [messages]="lotNumberInputMessages"
                    [showViewMode]="isInViewMode"
                    [validators]="fullLotNumberValidators"
                    [maxLength]="9"
                    [warningLevel]="WarningsEnum.WARNING_PNC_SEND"
                    label="{{lotNumberLabel}}"
                    placeholder="e.g. E4R5T7896"></app-input-text>
    <app-input-text #quantityInput
                    (inputStateChange)="manageQuantityMessages($event)"
                    (inputValueChange)="quantityChange($event)"
                    [baseCypressTag]="quantityBaseCypressTag"
                    [hasSearchIcon]="false"
                    [initialValue]="quantityDisplayFormatted(isInViewMode, quantity)"
                    [messages]="quantityInputMessages"
                    [showViewMode]="isInViewMode"
                    [validators]="quantityValidators"
                    [maxLength]="6"
                    label="Quantity"
                    placeholder="e.g. 1"></app-input-text>
</app-part-number-changes-additional-input>
